module.exports = __webpack_public_path__ + "img/Polygon-active.089e5d99.png";